import { cloudFunctionsEndpoints, getBaseCloudFunctionsUrl } from "../../common/configs/CommonCloudFunctions";

export const getRecoveryPasswordCloudFunctionsUrl = (isProdEnvironment: boolean) => {
    return `${getBaseCloudFunctionsUrl(isProdEnvironment)}${cloudFunctionsEndpoints.recovery_password}`
}